export const appHead = {"link":[{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon-96x96.png?v=2"},{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg?v=2"},{"rel":"shortcut icon","href":"/favicon.ico?v=2"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png?v=2"},{"rel":"manifest","href":"/site.webmanifest?v=2"}],"meta":[{"charset":"utf8"},{"name":"apple-mobile-web-app-title","content":"johnsenpartner"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"description","content":"johnsenpartner. architekten ist ein Architekturbüro in Solingen, das sich auf die Planung und Realisierung von Wohn- und Gewerbebau spezialisiert hat."},{"name":"johnsenpartner. architekten","content":"johnsenpartner. architekten ist ein Architekturbüro in Solingen, das sich auf die Planung und Realisierung von Wohn- und Gewerbebau spezialisiert hat."},{"name":"msapplication-TileColor","content":"#c10050"},{"name":"theme-color","content":"#ffffff"},{"name":"robots","content":"max-image-preview:large, index, follow, max-snippet:-1, max-video-preview:-1"},{"name":"geo.region","content":"DE-NW"},{"name":"geo.placename","content":"Solingen"},{"name":"geo.position","content":"51.16181040420932;7.006048662199611"},{"name":"ICBM","content":"51.16181040420932, 7.006048662199611"},{"name":"author","content":"johnsenpartner. architekten"},{"name":"publisher","content":"johnsenpartner. architekten"},{"name":"copyright","content":"johnsenpartner. architekten"},{"name":"language","content":"de"},{"name":"op:locale","content":"de_DE"},{"name":"op:type","content":"website"},{"name":"op:site_name","content":"johnsenpartner. architekten"},{"name":"op:email","content":"west@johnsenpartner.de"},{"name":"op:title","content":"johnsenpartner. architekten"},{"name":"op:description","content":"johnsenpartner. architekten ist ein Architekturbüro in Solingen, das sich auf die Planung und Realisierung von Wohn- und Gewerbebau spezialisiert hat."},{"name":"op:url","content":"https://johnsenpartner.de"},{"name":"og:image","content":"https://www.johnsenpartner.de/images/muengstener_bruecke.jpg"},{"name":"og:title","content":"johnsenpartner. architekten"},{"name":"og:description","content":"johnsenpartner. architekten bietet Ihnen das gesamte Spektrum der Architektenleistungen. Mit uns werden Ihre Ideen Wirklichkeit."},{"name":"og:url","content":"https://johnsenpartner.de"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":"https://www.johnsenpartner.de/images/muengstener_bruecke.jpg"},{"name":"twitter:title","content":"johnsenpartner. architekten"},{"name":"twitter:description","content":"johnsenpartner. architekten bietet Ihnen das gesamte Spektrum der Architektenleistungen. Mit uns werden Ihre Ideen Wirklichkeit."},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"charset":"utf8","htmlAttrs":{"lang":"de"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false